import { render } from "./BlogImplantsQuality.vue?vue&type=template&id=b1b64cea"
import script from "./BlogImplantsQuality.vue?vue&type=script&lang=js"
export * from "./BlogImplantsQuality.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__